<form #reviewAndSubmitForm="ngForm" novalidate>
  <div class="row">
    <div class="col-12">
      <div class="review box">
        <div class="row">
          <div class="col-12">
            <div>
              <h2>Application Submission</h2>
              <p>You may review and edit your application by clicking the editable sections of the job application outline. Click Review & Submit to return to this page to submit your application. Note: The content, requirements, questions, and any other criteria associated with this job posting may change at any time.</p>
            </div>
            <div [innerHTML]="model.certifications.intro"></div>
            <div *ngIf="model.applicantTextEnabled && applicantTextConsentQuestion !== undefined && applicantTextConsentQuestion !== null">
              <h3 style="margin-bottom:20px"><b>Communications Opt In</b></h3>
              <app-yes-no [question]="applicantTextConsentQuestion" [element]="model.certifications"></app-yes-no>
              <br *ngIf="applicantCallConsentFlagEnabled" />
              <app-yes-no [question]="applicantCallConsentQuestion" [element]="model.certifications" *ngIf="applicantCallConsentFlagEnabled"></app-yes-no>
            </div>
          </div>

          <div class="col-12" style="margin-top: 20px; margin-bottom: 20px;">
            <h3><b>Certify and Submit</b></h3>
          </div>

          <div class="col-6" *ngIf="firstNameQuestion !== undefined && firstNameQuestion !== null">
            <div class="form-group">
              <label class="required">First Name</label>
              <input name="firstName" #firstNameAnswer="ngModel" mdbInput type="text" class="form-control" mdbValidate required [pattern]="model.applicantName.firstName" [(ngModel)]="firstNameQuestion.answers[0].value" />
              <mdb-error *ngIf="firstNameAnswer.invalid && (firstNameAnswer.dirty || firstNameAnswer.touched)">First Name is required and must match what was previously added.</mdb-error>
            </div>
          </div>
          <div class="col-6" *ngIf="lastNameQuestion !== undefined && lastNameQuestion !== null">
            <div class="form-group">
              <label class="required">Last Name</label>
              <input name="lastName" #lastNameAnswer="ngModel" mdbInput type="text" class="form-control" mdbValidate required [pattern]="model.applicantName.lastName" [(ngModel)]="lastNameQuestion.answers[0].value" />
              <mdb-error *ngIf="lastNameAnswer.invalid && (lastNameAnswer.dirty || lastNameAnswer.touched)">Last Name is required and must match what was previously added.</mdb-error>
            </div>
          </div>
          <div class="col-12" *ngIf="firstNameQuestion !== undefined && firstNameQuestion !== null" style="margin-top:20px"></div>
          <div class="col-12">
            <app-multiple-choice *ngIf="certificationQuestion !== undefined && certificationQuestion !== null" [question]="certificationQuestion" [element]="model.certifications"></app-multiple-choice>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2 formActions">
    <div class="col-12 text-right">
      <button class="btn-default btn" mdbWavesEffect (click)="displayCancelModal()">Cancel</button>
      <button class="btn-outline btn" mdbWavesEffect (click)="back()">Previous</button>
      <button class="btn btn-primary" mdbWavesEffect [disabled]="!canSubmit() || processingServerSideRequest" (click)="save()">
        <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="processingServerSideRequest"></i> Submit
      </button>
    </div>
  </div>
</form>

<div mdbModal #cancelModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="cancel()" novalidate>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancelModal.hide()">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">Cancel Job Application</h4>
        </div>
        <div class="modal-body">
          By canceling, you will lose all data and you'll return to the open jobs page. Are you sure you want to cancel?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" aria-label="Close" (click)="cancelModal.hide()" mdbWavesEffect>No</button>
          <button type="submit" class="btn btn-primary" mdbWavesEffect>Yes</button>
        </div>
      </div>
    </form>
  </div>
</div>
